export default function Footer(el, {
    activeClass = 'is-active',
}) {
    const groupToggles = el.querySelectorAll('nav button');

    groupToggles.forEach(t => {
        t.onclick = () => {
            t.parentElement.classList.toggle(activeClass);
        };
    });
}
